export enum AppErrorType {
  BAD_CONFIGURATION = 'BAD_CONFIGURATION',
  GENERIC_ERROR = 'GENERIC_ERROR',
}

export type AppErrorRetryCallback = () => void

export interface AppError {
  error?: string | Error
  errorType?: AppErrorType
  errorMessage?: string
  retryCallback?: AppErrorRetryCallback
}
